import React from 'react';

/**
 * AssessmentFooterActions
 *
 * Props:
 * - step: current step number
 * - goToNextStep: function to advance to the next step
 * - goToPreviousStep: function to go back a step
 * - handleSubmitAssessment: function to submit the assessment
 - isSubmitting: boolean indicating if submission is in progress
 */
const AssessmentFooterActions = ({
  step,
  goToNextStep,
  goToPreviousStep,
  handleSubmitAssessment,
  isSubmitting
}) => {
  return (
    <div className="flex justify-between items-center mt-8">
      <button
        type="button"
        onClick={goToPreviousStep}
        disabled={step === 1}
        className="px-6 py-3 bg-gray-600 dark:bg-gray-700 text-white rounded-lg font-medium hover:bg-gray-700 dark:hover:bg-gray-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
      >
        Previous
      </button>

      {step < 4 ? (
        <button
          type="button"
          onClick={goToNextStep}
          className="px-6 py-3 bg-emerald-600 dark:bg-emerald-500 text-white rounded-lg font-medium hover:bg-emerald-700 dark:hover:bg-emerald-600 transition-colors"
        >
          Next
        </button>
      ) : (
        <button
          type="button"
          onClick={handleSubmitAssessment}
          disabled={isSubmitting}
          className="px-6 py-3 bg-emerald-600 dark:bg-emerald-500 text-white rounded-lg font-medium hover:bg-emerald-700 dark:hover:bg-emerald-600 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? (
            <div className="flex items-center">
              <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white mr-2" />
              Submitting...
            </div>
          ) : (
            'Submit Assessment'
          )}
        </button>
      )}
    </div>
  );
};

export default AssessmentFooterActions;


